export default {
  localization: {
    defaultLocale: 'en',
  },
  analytics: {
    google: '',
  },
  header: {
    fixed: true,
    offset: 100,
    offsetMobile: 60,
  },
  recaptcha: {
    key: '6LcU3OUUAAAAAOnhrnUnjG4Em6SP1DlzWxXtLlYb',
  },
  validate: {
    bookingReference: (field) => {
      const TICKET_NUMBER_FORMAT = /^(082)-?(?!455)\d{10}$/

      return TICKET_NUMBER_FORMAT.test(field.value) ? '' : 'invalid'
    },
  },
}
